/**
 * ACS 5-year public release timing (approximate, check census.gov each year):
 * - New 5-year datasets usually publish in **December** (e.g. 2022 ACS 5yr released late 2023).
 * - Plan to bump `REACT_APP_ACS_DATASET_YEAR` and re-run `npm run refresh:zcta-official-codes` once
 *   the Census API exposes the new vintage and ZCTA list is refreshed.
 *
 * @returns {number} ACS dataset year used in API paths (`/data/{year}/acs/acs5/...`).
 */
export function getAcsDatasetYear() {
  const raw = typeof process !== "undefined" ? process.env.REACT_APP_ACS_DATASET_YEAR : undefined;
  const n = raw != null && raw !== "" ? parseInt(String(raw), 10) : NaN;
  if (Number.isFinite(n) && n >= 2010) return n;
  return 2022;
}

export function acsFiveYearVintageLabel(year = getAcsDatasetYear()) {
  return `ACS ${year} 5-year (Census Bureau)`;
}
